import * as React from "react";
import * as RenderMethods from "./RenderMethods";
import { EventCardProps } from "../EventCard";
import { renderMarkets } from "../EventCard/RenderMethods";
import { observer } from "mobx-react";

@observer
export class MiniEventCard extends React.Component<EventCardProps, {}> {
    cardTypeClass: string
    buttonsHolderClass: string
    componentPrefix: string

    /* istanbul ignore next */
    /* super transpiles to  var _this = _super.call(this) || this; */
    constructor(props) {
        super(props);

        this.cardTypeClass = "";
        this.componentPrefix = "mini-ev-card";
        this.buttonsHolderClass = `rj-ev-list__${this.componentPrefix}__buttons-holder`;
    }

    renderMarkets = renderMarkets;
    renderCardDetails = RenderMethods.renderMiniCardDetails;

    render() {
        const isSelected = this.props.event.isSelected ? `rj-ev-list__${this.componentPrefix}--selected` : "";
        const inKickOff = this.props.event.isInKickOffState ? `rj-ev-list__${this.componentPrefix}--in-kick-off` : "";

        return (
            <div className={`rj-ev-list__${this.componentPrefix} ${this.cardTypeClass} ${isSelected} ${inKickOff}`} data-uat={`div-ev-list-${this.componentPrefix}`}>
                {this.renderCardDetails(this.props.event, this.props.handlers, this.props.isFavoritesEnabled, this.componentPrefix, this.props.dict)}
                {this.props.showOddBtns && this.renderMarkets(this.props, this.buttonsHolderClass, this.componentPrefix)}
            </div>
        )
    }
}